import styled from 'styled-components';

export const TextFieldsWrapper = styled('span')`
  display: flex;
  align-items: center;
  & > * {
    :first-child {
      flex: 0.8;
    }
    :nth-child(2) {
      flex: 0.2;
      margin-right: 1rem;
    }
  }
`;
